import Hero from '../components/Hero'; 
import Highlights from "../components/Highlights";
import Highlights2 from "../components/Highlights2";
import Highlights3 from "../components/Highlights3";
import Footer from "../components/Footer";

function Home() {
  return (
    <div>
      <Hero />
      <Highlights />
      <Highlights2 />
      <Highlights3 />
      <Footer/>
    </div>
  );
}

export default Home;
